import { VSecureFileUserAccessRequest, VSecureFileUserAccessResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class UserAccessEndpoint extends EncryptedEndpoint {
    async getRequestInit({ fileId, users }) {
        const requestBytes = VSecureFileUserAccessRequest.encode({
            fileId,
            users
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VSecureFileUserAccessResponse.decode(responseBytes);
    }
}
export const userAccessEndpoint = new UserAccessEndpoint({
    path: '/encryptions/users/list',
    method: 'POST',
    sideEffect: true,
    schema: VSecureFileUserAccessResponse
});
